import * as types from './mutation-types'

export default {
  
  [types.RESET_CURRENT_USER] (state, user) {
    state.currentUser = null
  },
  [types.BOOTSTRAP_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.UPDATE_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.ADD_CODEPROMO](state, data) {
    state.codePromos.push(data)
  },
  [types.ADD_CODEPROMOS](state, data) {
    state.codePromos = data.codePromos
  },
  [types.SET_CODE_PROMO_STATUS](state, data) {
    state.codePromoStatus = data
  },
  [types.LOAD_DISCOUNT_TYPES](state, data) {
    state.discountTypes = data
  },

}
